import { CommApiInstance } from "Utils/CommApiInstance";

const PymtMthdLstApi = async (
    gameSvcCd:string,
    prdtCd:string,
) => {
    
    return await CommApiInstance.post(`/pymt/${gameSvcCd}/${prdtCd}/pymt_mthd_lst`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
    
}
export default PymtMthdLstApi;